import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts/NunitoSans-VariableFont_YTLC,opsz,wdth,wght.ttf";
import "./index.scss";
import App from "./App";
import TagManager from "react-gtm-module";
import reportWebVitals from "./reportWebVitals";
import config from "./config";

if (process.env.NODE_ENV === "production") {
  const tagManagerArgs = {
    gtmId: config.gtmId,
  };
  TagManager.initialize(tagManagerArgs);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
